import { html, ref } from '@microsoft/fast-element';
/**
 * @internal
 */
export const DynamicTemplate = html `
  <zero-design-system-provider ${ref('provider')}>
    <div class="dynamic-template">${(x) => x.selectTemplate()}</div>
  </zero-design-system-provider>
`;
/**
 * @internal
 */
export const LoadingTemplate = html `
  <fast-progress></fast-progress>
`;
/**
 * @internal
 */
export const MainTemplate = html `
  <zero-design-system-provider data-test-id="design-system-provider">
    <div class="dynamic-template">
      <foundation-router
        @luminance-icon-clicked=${(x) => x.onLuminanceToggle()}
        :config=${(x) => x.config}
      ></foundation-router>
    </div>
  </zero-design-system-provider>
`;
